import axios from "axios";

export const getRandomSalt = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API}/Auth/random-salt`
    );

    return response.data.salt;
  } catch (error) {
    console.error(error);
  }
};
